import React from 'react';
import { PRODUCT, SUPPORT_EMAIL, BRAND } from '../data/content';
export function Footer() {
  return <footer className="bg-night-strong" data-id="element-86" data-mp="3gfiuujlrgden">
      <div className="mx-auto max-w-page px-4 sm:px-6 lg:px-8 py-12 text-center" data-id="element-87" data-mp="3ggk7utmc79z0">
        <p className="font-display text-lg md:text-xl font-bold uppercase tracking-[0.12em] text-gold-light" data-id="element-88" data-mp="32pff8bhdzhy6">
          Leé. Comprendé. Reflexioná. Aplicá.
        </p>
        <p className="mt-4 text-sm font-semibold uppercase tracking-[0.18em] text-white/80" data-id="element-89" data-mp="3ueih5klswg7n">
          Creado por {BRAND}
        </p>
        <p className="mt-2 text-sm text-white/70" data-id="element-90" data-mp="387ejk1577e7">
          Soporte:{' '}
          <a href={`mailto:${SUPPORT_EMAIL}`} className="font-semibold text-gold-bright underline underline-offset-4 transition-colors duration-150 ease-soft hover:text-gold-light" data-id="element-91" data-mp="3ldamdcihtxib">
            {SUPPORT_EMAIL}
          </a>
        </p>

        <div className="mx-auto mt-8 max-w-3xl border-t border-white/15 pt-6 text-xs leading-relaxed text-white/55" data-id="element-92" data-mp="2ey09s9ubckip">
          <p data-id="element-93" data-mp="3l8qvi1vp0fqe">© 2026 {BRAND}. Todos los derechos reservados.</p>
          <p className="mt-1" data-id="element-94" data-mp="3lbdbmpwng3k8">
            {PRODUCT} es un recurso educativo de estudio y reflexión bíblica. No
            garantiza resultados personales o espirituales específicos.
          </p>
          <p className="mt-1" data-id="element-95" data-mp="3v5dgcqo0r6sf">
            Este sitio no forma parte de Facebook ni de Meta Platforms, Inc. y
            no está respaldado, patrocinado ni administrado por dichas
            compañías.
          </p>
        </div>
      </div>
    </footer>;
}